import type { ITSPayloadBoard } from '../../@types/ITSPayload.js';
import BoardScore from './BoardScore.js';

class BoardFulltraff extends BoardScore {
  /**
   * Loops over outcomes to generate correct data for all outcomes.
   *
   * @returns outcomes as hex string
   */
  override composeOwnRows(): ITSPayloadBoard<string> {
    const hexString = this.outcomes
      .map((signArray) =>
        signArray
          .reduce((acc, signs) => {
            let ret = acc;
            signs.flat().map(
              (signIndex) =>
                // bitshift user selection index positions to binary eg, 0 (1), 1(2), -(4) => 1 + 2 => decimal 3 => binary 0011
                (ret |= 1 << signIndex)
            );
            return ret;
          }, 0)
          // convert to hex
          .toString(16)
          // use leading 0, due to 8+ outcomes (binary 1111 1111 => hex FF => decimal 255)
          .padStart(2, '0')
      )
      .join('')
      .toUpperCase();

    type ITSBoardFulltraff = ITSPayloadBoard<typeof hexString>;

    return hexString as ITSBoardFulltraff;
  }
}

export default BoardFulltraff;
